module.exports = __webpack_public_path__ + "static/media/Logo_SAPIT.5616d9ad.png";